import {
  DEFAULT_CATALOG_ITEMS_PER_PAGE,
  DEFAULT_CATALOG_PAGE,
  SECTIONS_SUGGESTION_CONFIG,
} from 'core/constants/catalogue.constants';
import { ESuggestedProductType } from 'core/model/enums/catalog.enum';
import { ISuggestionSection, TSectionsSuggestionConfig } from 'core/model/interfaces/catalogues.interface';
import { catalogsService } from 'core/services/catalogs/catalogs.service';
import { type TSliceExtraReducer } from 'core/store';
import { getCustomerIdFromCheckout } from 'core/store/checkout/checkout-state.utils';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { SLICE_NAMESPACE } from '../constants';
import { ISuggestedProductsState } from '../types';

export const getSuggestedProducts = createAppAsyncThunk<
  Array<ISuggestionSection>,
  { sectionId: keyof TSectionsSuggestionConfig; itemsPerPage?: number }
>(
  `${SLICE_NAMESPACE}/getSuggestedProducts`,
  async ({ sectionId, itemsPerPage = DEFAULT_CATALOG_ITEMS_PER_PAGE }, { getState }) => {
    const state = getState();
    const { checkout } = state;
    const customerId = getCustomerIdFromCheckout(checkout);

    const typesForSection = SECTIONS_SUGGESTION_CONFIG[sectionId];

    const suggestions = await Promise.all<Array<Promise<ISuggestionSection>>>(
      typesForSection.map((suggestionType: ESuggestedProductType) =>
        catalogsService.getSuggestions(
          {
            suggestionTypeId: suggestionType,
            itemsPerPage,
            page: DEFAULT_CATALOG_PAGE,
          },
          customerId,
        ),
      ),
    );

    return suggestions;
  },
);

export const getSuggestedProductsReducer: TSliceExtraReducer<ISuggestedProductsState> = builder => {
  builder
    .addCase(getSuggestedProducts.pending, (state, action) => {
      const { sectionId } = action.meta.arg;
      state.sections[sectionId].isLoading = true;
    })
    .addCase(getSuggestedProducts.rejected, (state, action) => {
      const { sectionId } = action.meta.arg;

      state.sections[sectionId] = {
        isLoading: false,
        suggestions: [],
      };
    })
    .addCase(getSuggestedProducts.fulfilled, (state, action) => {
      const { sectionId } = action.meta.arg;
      const suggestions = action.payload;

      state.sections[sectionId] = {
        isLoading: false,
        suggestions: suggestions || [],
      };
    });

  return builder;
};
